
import React, {useMemo, useState} from "react";
import {useProject} from "./ClientProjectProvider";
import {useParams, useSearchParams} from "react-router-dom";
import ProjectPosition from "../models/ProjectPosition";
import {useQueryClient} from '@tanstack/react-query';
let ProjectPositionContext = React.createContext(null);

const ProjectPositionProvider = ({children, positionId, model}) => {

    const projectContext = useProject();

    const {project, isLoading, update, postUpdate, isProjectUpdating, updateProjectPosition} = projectContext || {}
    const [isUpdating, setIsUpdating] = useState(false);
    const [searchParams] = useSearchParams()
    const params = useParams();
    const queryClient = useQueryClient();

    const position = useMemo(() => {
            if (model) return model;
            let matchId;

            if(positionId) {
                matchId = parseInt(positionId)
            }else if(params?.positionId) {
                matchId = parseInt(params.positionId)
            }else if(searchParams.get('role')) {
                matchId = parseInt(searchParams.get('role'))
            }


            if(isLoading || (!matchId && !model)) {
                return {
                    name: "ProjectPositionProvider",
                    isLoading,
                    position: undefined
                }
            }

            return TB.find(project?.positions || [], ['id', matchId]);
        },
        [project?.positions, positionId, model, params?.positionId, searchParams.get('role'), isLoading, isUpdating, isProjectUpdating]
    );

    const displayIndex = useMemo(() => {
        return TB.findIndex(project.positions || [], ['id', position.id]) + 1
    }, [ project?.positions?.length, isProjectUpdating]);

    const value = {
        name: "ProjectPositionProvider",
        isLoading,
        position,
        displayIndex,
        isDisabled: isUpdating,
        updatePosition: async(props, postToBackend = true) => {
            // postToBackend defaulted - set to false if only want to update position locally
            let didUpdate = await updateProjectPosition(ProjectPosition.make({...position, ...props}), postToBackend)

            if (!didUpdate) {
                return TB.showServerErrorToast();
            }
            if (postToBackend) {
                await TB.toast("Role updated successfully!")
            }
        },
        deletePosition: async() => {

            let updatedProject = await project.confirmDeletePosition(
                position
            );

            if (!updatedProject) {
                return;
            }
            return true;
        },
        reopenPosition: async() => {
            if(!position.assignedCandidate?.()) return;
            if (project?.hasRequestedSOW()) {
                return TB.toast("Can't reopen after SOW has already been requested!", {theme: 'danger'})
            }
            await setIsUpdating(true)
            try {
                let updatedCandidate = await position.assignedCandidate().unassignFromPosition(
                    project, position
                )

                await setIsUpdating(false);
                await queryClient.invalidateQueries({
                    predicate: ({queryKey}) => {
                        let params = queryKey[1] || {};
                        return queryKey[0] === 'positionMatches' && params.project_position === position.id;
                    }
                })
                if (!updatedCandidate) {
                    await setIsUpdating(false)
                    return false;
                }

                TB.sysAlert('byo.removed_for_role_button_clicked');

            }catch (e) {
                console.error('Reopen Position', e)

                await setIsUpdating(false);
            }
            return true
        }
    }

    return (
        <ProjectPositionContext.Provider value={value}>
            {children}
        </ProjectPositionContext.Provider>
    );
}


const usePosition = () => {
    return React.useContext(ProjectPositionContext);
}

export {
    usePosition,
    ProjectPositionProvider,
    ProjectPositionContext
}